module.exports = __webpack_public_path__ + "res/34-img_game_bg_1.822fcf19e11acc936d8ac482295c99d2.png";